module.exports = __webpack_public_path__ + "img/slt2.80e55014.png";